import { useCallback, useState } from "react";
import { AxiosError, AxiosResponse } from "axios";
import { ICollection } from "../../../utils/interfaces/collection.interface";
import { handleBackendError } from "../../../utils/helpers";
import { useTranslation } from "react-i18next";
import { IPaginationParams } from "../../../utils/interfaces/pagination-params.interface";
import { IResource } from "../../../utils/interfaces/resource.interface";
import IndustryRepository from "../../../repositories/industry-repository";
import { IndustryList } from "../list/interface";
import { Industry } from "../../../models/industry";

export const useGetIndustry = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<IndustryList[]>([]);
  const [totalData, setTotalData] = useState<number>(0);
  const [isOnFetchingData, setIsOnFetchingData] = useState<boolean>(false);

  const [industryData, setIndustryData] = useState<Industry | null>(null);
  const [isOnFetchingIndustryData, setIsOnFetchingIndustryData] =
    useState<boolean>(false);

  const loadData = useCallback(async (params: IPaginationParams) => {
    setIsOnFetchingData(true);

    await IndustryRepository.all(params)
      .then((response: AxiosResponse<ICollection<IndustryList[]>>) => {
        setData(response.data.data);
        setTotalData(response.data.meta.total);
      })
      .catch(() => {})
      .finally(() => {
        setIsOnFetchingData(false);
      });
  }, []);

  const loadIndustryData = useCallback(
    async (id: string, params: any = null) => {
      setIsOnFetchingIndustryData(true);

      await IndustryRepository.show(id, params)
        .then((response: AxiosResponse<IResource<Industry>>) => {
          setIndustryData(response.data.data);
        })
        .catch((e: AxiosError) => {
          handleBackendError(e, t("notification.error.default"));
        })
        .finally(() => {
          setIsOnFetchingIndustryData(false);
        });
    },
    [t]
  );

  return {
    data,
    totalData,
    loadData,
    isOnFetchingData,
    loadIndustryData,
    isOnFetchingIndustryData,
    industryData,
  };
};
